export class ProfessionalAccountMeta {
  /**
   * @var {boolean}
   */
  isPrimary;

  constructor(model = {}) {
    this.isPrimary = model.isPrimary;
  }
}
